import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { trpc } from '@/lib/trpc';

interface ProductFilterBarProps {
  search: string;
  onSearchChange: (v: string) => void;
  brandId: string | undefined;
  onBrandChange: (v: string | undefined) => void;
  modelId: string | undefined;
  onModelChange: (v: string | undefined) => void;
}

export function ProductFilterBar({
  search,
  onSearchChange,
  brandId,
  onBrandChange,
  modelId,
  onModelChange,
}: ProductFilterBarProps) {
  const { t } = useTranslation('trading');

  const { data: brandsData } = trpc.tradingBrand.list.useQuery({});
  const brands = brandsData?.brands ?? [];

  const { data: modelsData } = trpc.tradingModel.list.useQuery(
    { brandId },
    { enabled: !!brandId }
  );
  const models = modelsData?.models ?? [];

  return (
    <>
      <div className="relative flex-1 max-w-xs">
        <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder={t('products.searchPlaceholder')}
          aria-label={t('products.searchAriaLabel')}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-8 w-full border border-border bg-background pl-8 pr-3 text-sm focus:border-foreground focus:outline-none focus:ring-1 focus:ring-foreground/20"
        />
      </div>
      <select
        value={brandId ?? ''}
        aria-label={t('products.filterByBrand')}
        onChange={(e) => {
          onBrandChange(e.target.value || undefined);
          onModelChange(undefined);
        }}
        className="h-8 border border-border bg-background px-2 text-sm focus:border-foreground focus:outline-none focus:ring-1 focus:ring-foreground/20"
      >
        <option value="">{t('products.allBrands')}</option>
        {brands.map((brand) => (
          <option key={brand.id} value={brand.id}>
            {brand.code} - {brand.name}
          </option>
        ))}
      </select>
      {brandId && (
        <select
          value={modelId ?? ''}
          aria-label={t('products.filterByModel')}
          onChange={(e) => onModelChange(e.target.value || undefined)}
          className="h-8 border border-border bg-background px-2 text-sm focus:border-foreground focus:outline-none focus:ring-1 focus:ring-foreground/20"
        >
          <option value="">{t('products.allModels')}</option>
          {models.map((model) => (
            <option key={model.id} value={model.id}>
              {model.code} - {model.name}
            </option>
          ))}
        </select>
      )}
    </>
  );
}
